// extracted by mini-css-extract-plugin
export default {"cls1":"Reader-cls1_eUW","cls2":"Reader-cls2_mgi Reader-cls1_eUW"};